// removed by extract-text-webpack-plugin
module.exports = {"container":"_28ppZtyDEZCmLGuAkvsc39_0","menu":"_1_2epAQ74VuxukwgU0T5wc_0","list":"_1oSu3DxM9ydvgQcGgyIUOf_0","pagination":"_7vqbiNK9eDBiX99uB_sHJ_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c1f0c15","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BreweriesList.vue
// module id = /iPE
// module chunks = 1